import { createSlice } from "@reduxjs/toolkit";
import { setCompanyCategory, setProfileMapData, setTabDetails, setParentStatusHandler, setCompanyProfileTypeHandler, setBuyerCachingHandler, setSupplierCachingHandler, setLogisticsCachingHandler, setCorporateHierarchyCachingHandler } from "./companyProfile.action";
import { companyTabs } from "@containers/CompanyProfile/utils/enum.js";

let buyerCaching = {
  buyerCounts: {
    trade_country_count: null,
    location_count: null,
    trade_port_count: null,
  },
  trade_country: null,
  trade_country_must_not: [],
  port: null,
  port_must_not: [],
  location: null,
  location_must_not: [],
  trading_partner: null,
  hs_code: null,
  shipmentDistribution: null,
  profileDetails: {},
  aiSummary: {},
};

let supplierCaching = {
  supplierCounts: {
    trade_country_count: null,
    location_count: null,
    trade_port_count: null,
  },
  trade_country: null,
  trade_country_must_not: [],
  port: null,
  port_must_not: [],
  location: null,
  location_must_not: [],
  trading_partner: null,
  hs_code: null,
  shipmentDistribution: null,
  profileDetails: {},
  aiSummary: {},
};

let logisticsCaching = {
  vocc: null,
  nvocc: null,
  freight_forwarder: null,
  aiSummary: {},
};

const companyProfileSlice = createSlice({
  name: "companyProfile",
  initialState: {
    countDetails: {
      loading: true,
    },
    companyCategory: null,
    tabDetails: {
      activePanelId: "",
      activeTabId: companyTabs[0].id,
      mapType: "trade_lane",
      activeTab: companyTabs[0],
    },
    buyerCaching: {
      ...buyerCaching,
    },
    supplierCaching: {
      ...supplierCaching,
    },
    logisticsCaching: {
      ...logisticsCaching,
    },
    corporateHierarchyCaching: {},
    isParentSubs: true,
    companyProfileType: null,
  },
  reducers: {
    profileMapDataHandler: setProfileMapData,
    companyCategoryHandler: setCompanyCategory,
    tabDetailsHandler: setTabDetails,
    parentStatusHandler: setParentStatusHandler,
    companyProfileTypeHandler: setCompanyProfileTypeHandler,
    buyerCachingHandler: setBuyerCachingHandler,
    supplierCachingHandler: setSupplierCachingHandler,
    logisticsCachingHandler: setLogisticsCachingHandler,
    corporateHierarchyCachingHandler: setCorporateHierarchyCachingHandler,
    resetCachingHandler: (state) => {
      state.buyerCaching = { ...buyerCaching, profileDetails: state.buyerCaching.profileDetails, aiSummary: state.buyerCaching.aiSummary };
      state.supplierCaching = { ...supplierCaching, profileDetails: state.supplierCaching.profileDetails, aiSummary: state.supplierCaching.aiSummary };
      state.logisticsCaching = { ...logisticsCaching, profileDetails: state.logisticsCaching.profileDetails, aiSummary: state.logisticsCaching.aiSummary };
      state.corporateHierarchyCaching = {};
      state.companyCategory = null;
    },
  },
});

export const { profileMapDataHandler, companyCategoryHandler, tabDetailsHandler, parentStatusHandler, companyProfileTypeHandler, buyerCachingHandler, supplierCachingHandler, logisticsCachingHandler, corporateHierarchyCachingHandler, resetCachingHandler } = companyProfileSlice.actions;

export default companyProfileSlice.reducer;
